import React from "react";
import "./SocialMedia.css";

export default function socialMediaFfixed() {
  return (
    <nav class="social">
      <ul>
        <li>
          <a href="https://github.com/lord2anil">
            Github <i className="fab fa-github"></i>{" "}
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/anil-rundla-311a7121b">
            Linkedin <i className=" fab fa-linkedin-in"></i>
          </a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/1R2uQq1qnDTeX-_Mv5Lzujb8kyNxo6zh7/view?usp=share_link">
            Resume{" "}
            <i class="fas fa-address-card" style={{ fontSize: "26px" }}></i>
          </a>
        </li>
        {/* <li><a href="http://behance.net/gianm">Behance <i className=" fab fa-behance"></i></a></li> */}
      </ul>
    </nav>
  );
}
